import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Our Range of <span>Real Estate</span> App Development Services
            </h2>
            <p>
              Our comprehensive real estate app development services make it
              easier for buyers to find the perfect home and allow agents to
              complete transactions more swiftly.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Real Estate Management App</h4>
                  <p>
                    Our real estate management app allows you to effectively
                    manage property listings, keep track of transactions, and
                    foster seamless communication between buyers, sellers, and
                    agents.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Enterprise Real Estate App Development</h4>
                  <p>
                    For large-scale real estate enterprises, we provide
                    customized property finance applications. Our software
                    solutions are strong, meet your strategic objectives, and
                    improve operational effectiveness.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Real Estate Web App Development</h4>
                  <p>
                    Our real estate app developers specialize in developing
                    dynamic and responsive websites that showcase property
                    listings. Our Web3 real estate app development solutions
                    enhance user engagement and attract potential clients.
                  </p>
                </div>

                <div className="robust-content">
                  <h4>Real Estate Agent Apps</h4>
                  <p>
                    We are a premier real estate app development company
                    dedicated to building agent apps that simplify property
                    management, improve client communication, and streamline
                    appointment scheduling.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Property Financing Applications</h4>
                  <p>
                    Our property financing apps simplify the mortgage process
                    with features like loan calculators, document submission,
                    and interest rate comparisons, enhancing user experience and
                    streamlining transactions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Property Marketing Applications</h4>
                  <p>
                    We empower businesses with mobile apps that enhance targeted
                    marketing in real estate, allowing you to send personalized
                    notifications based on user data and preferences to
                    effectively engage potential buyers.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
